import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from 'src/app/modules/primeng.module';
import { EntityPageComponent } from './entity-page.component';

@NgModule({
    imports: [CommonModule, TranslateModule, PrimengModule],
    declarations: [EntityPageComponent],
    exports: [EntityPageComponent],
})
export class EntityPageModule {}
